import { withInstall } from 'framework/utils'
import { useComponentRegister } from 'framework/components/Form/index'

import index from './index.vue'

// 将admin的component注入到 framenwork的Form组件中
;[['AppGroupSelect', index]].forEach(([name, comp]) => {
  useComponentRegister(name as any, comp)
})

export const AppGroupSelect = withInstall(index)
